import React, { useState } from "react";
import { FiSend, FiMail, FiMapPin } from "react-icons/fi";
import Frame from "../chrome/Frame";
import Seo from "../chrome/Seo";
import copy from "../lib/copy";

const Contact = () => {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({
    name: "", company: "", email: "", sector: "FMCG & Consumer Goods", phase: "Pre-launch", message: ""
  });
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = (e) => { e.preventDefault(); setSent(true); };

  return (
    <Frame>
      <Seo title="Contact" description={`Reach out to ${copy.brand} — Belgrade-based marketing studio for international brands entering Türkiye.`} />

      <section className="svc-hero">
        <div className="shell">
          <div className="crumb">
            <a href="/">Home</a><span className="sep">/</span> Contact
          </div>
          <span className="eyebrow">Send us a brief</span>
          <h1>Tell us about the brand, the category and the Türkiye window you have in mind.</h1>
          <p className="lede">
            A few honest lines is enough to start. We respond within one business day with a candid view — even if our
            view is that the timing is not yet right.
          </p>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="dispatch">
            <div className="dispatch-info">
              <span className="eyebrow">Direct channels</span>
              <h2 style={{ fontSize: "2rem" }}>The fastest way in.</h2>
              <p style={{ color: "#5d6e78", marginBottom: "2rem" }}>
                For most enquiries the form on the right is the quickest route. The channels below also land directly
                with the senior team.
              </p>

              <div className="block">
                <div className="lbl"><FiMail style={{ marginRight: 6 }} /> E-mail</div>
                <a className="val" href={`mailto:${copy.contact.email}`}>{copy.contact.email}</a>
              </div>
              <div className="block">
                <div className="lbl"><FiMapPin style={{ marginRight: 6 }} /> Office</div>
                <div className="val" style={{ lineHeight: 1.4 }}>
                  {copy.hq.address.line1}<br />
                  {copy.hq.address.line2}<br />
                  {copy.hq.address.country}
                </div>
              </div>
              <div className="block">
                <div className="lbl">Response</div>
                <div className="val">{copy.contact.response}</div>
              </div>
            </div>

            <div className="dispatch-form">
              {sent ? (
                <div style={{ textAlign: "center", padding: "2rem 0" }}>
                  <h3 style={{ marginBottom: ".5rem" }}>Thank you.</h3>
                  <p style={{ color: "#5d6e78" }}>
                    Your brief is on its way. A senior advisor will respond within one business day.
                  </p>
                </div>
              ) : (
                <form onSubmit={submit}>
                  <h3 style={{ marginBottom: ".3rem", fontSize: "1.7rem" }}>Send us a brief.</h3>
                  <p style={{ color: "#5d6e78", fontSize: ".95rem", marginBottom: "1.5rem" }}>
                    Anything you can share — yard, range, target market — helps us reply usefully on the first pass.
                  </p>

                  <div className="field field--row">
                    <div>
                      <label>Full name</label>
                      <input required value={form.name} onChange={update("name")} placeholder="Jane Doe" />
                    </div>
                    <div>
                      <label>Brand / Company</label>
                      <input value={form.company} onChange={update("company")} placeholder="Brand or company name" />
                    </div>
                  </div>

                  <div className="field field--row">
                    <div>
                      <label>E-mail</label>
                      <input required type="email" value={form.email} onChange={update("email")} placeholder="you@brand.com" />
                    </div>
                    <div>
                      <label>Phase</label>
                      <select value={form.phase} onChange={update("phase")}>
                        <option>Pre-launch</option>
                        <option>Year-one launch</option>
                        <option>Scale / year-two</option>
                        <option>Re-launch / repositioning</option>
                      </select>
                    </div>
                  </div>

                  <div className="field">
                    <label>Sector</label>
                    <select value={form.sector} onChange={update("sector")}>
                      <option>FMCG & Consumer Goods</option>
                      <option>Fashion & Luxury</option>
                      <option>Beauty & Cosmetics</option>
                      <option>Food & Beverage</option>
                      <option>Technology & SaaS</option>
                      <option>Travel & Hospitality</option>
                      <option>Automotive & Mobility</option>
                      <option>Health & Wellness</option>
                      <option>Home & Lifestyle</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div className="field">
                    <label>Brief</label>
                    <textarea
                      required
                      value={form.message}
                      onChange={update("message")}
                      placeholder="A few lines on the brand, the category and the timing you have in mind."
                    />
                  </div>

                  <div style={{ marginTop: ".5rem" }}>
                    <button type="submit" className="btn btn--ink">
                      Send brief <FiSend />
                    </button>
                  </div>

                  <p className="note">
                    Submissions are read only by the {copy.brand} senior team. We do not share or sell submitted information.
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </Frame>
  );
};

export default Contact;
